import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '@modules/shared.module';
import { UiGridModule } from '@uipath/angular/components/ui-grid';
import { UiSuggestModule } from '@uipath/angular/components/ui-suggest';
import { UiNgLetModule } from '@uipath/angular/directives/ui-ng-let';

import { ProcessRobotsGridComponent } from './process-robots.grid';

@NgModule({
    imports: [
        CommonModule,
        UiSuggestModule,
        SharedModule,
        UiGridModule,
        UiNgLetModule,
    ],
    declarations: [
        ProcessRobotsGridComponent,
    ],
    exports: [
        ProcessRobotsGridComponent,
    ],
})
export class ProcessGridModule { }
